import { render, staticRenderFns } from "./CertificateRequestTemplateList.vue?vue&type=template&id=634597b6&scoped=true"
import script from "./CertificateRequestTemplateList.vue?vue&type=script&lang=js"
export * from "./CertificateRequestTemplateList.vue?vue&type=script&lang=js"
import style0 from "./CertificateRequestTemplateList.vue?vue&type=style&index=0&id=634597b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634597b6",
  null
  
)

export default component.exports